<template>
  <div class="footer-box">
    <el-main class="content"
      >Copyright © 2020 ciyun.5118.com All Rights Reserved
      <a
        style="color: white;margin-left: 10px;"
        rel="nofollow"
        href="http://beian.miit.gov.cn/"
        target="_blank"
        >粤ICP备19157206号</a
      >
    </el-main>
  </div>
</template>

<script>
export default {
  componentName: "footer",
  computed: {},
  methods: {}
};
</script>

<style type="text/less" lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.footer-box {
  background-color: black;
  height: 60px;
  display: flex;
  align-items: center;
}

.footer-box .content {
  color: white;
  text-align: center;
  font-size: 10px;
  padding-top: 25px;
}
</style>
